import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

export const PGSErrorView: FC = () => {
  const { __ } = useTranslations();
  const config = useConfig();
  const description = `${__("cart.checkout.exception.pgs_error.message")} ${
    config.CONTACT_US_URL ? __("cart.checkout.exception.pgs_error.contact_us_message") : ""
  }`;

  const firstErrorAction = {
    label: __("cart.checkout.exception.pgs_error.action"),
    onClick: () => window.location.reload(),
  };

  const secondButtonAction = {
    label: __("cart.checkout.exception.pgs_error.contact_us_cta"),
    onClick: () => window.open(config.CONTACT_US_URL, "_self"),
  };

  return (
    <AlertBanner
      title={__("cart.checkout.exception.pgs_error.title")}
      description={description}
      tone="error"
      actions={config.CONTACT_US_URL ? [firstErrorAction, secondButtonAction] : [firstErrorAction]}
    />
  );
};
